import { Link } from 'react-router-dom'
import type { ComponentProps, ReactNode } from 'react'

type Variant = 'primary' | 'secondary' | 'gold' | 'ghost'
type Size = 'md' | 'sm'

type Common = {
  children: ReactNode
  variant?: Variant
  size?: Size
  className?: string
}

type ButtonAsButton = Common &
  Omit<ComponentProps<'button'>, 'children' | 'className'> & {
    to?: undefined
  }

type ButtonAsLink = Common & {
  to: string
}

function classNames(variant: Variant, size: Size, className?: string) {
  return [
    'pp-btn',
    `pp-btn--${variant}`,
    size === 'sm' ? 'pp-btn--sm' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ')
}

export function Button(props: ButtonAsButton | ButtonAsLink) {
  const { children, variant = 'primary', size = 'md', className } = props
  const cls = classNames(variant, size, className)

  if ('to' in props && props.to) {
    return (
      <Link to={props.to} className={cls}>
        {children}
      </Link>
    )
  }

  const {
    type = 'button',
    children: _children,
    variant: _variant,
    size: _size,
    className: _className,
    ...rest
  } = props as ButtonAsButton
  return (
    <button type={type} className={cls} {...rest}>
      {children}
    </button>
  )
}
